export const FETCH_HOTEL_DATA_DETAILED = 'redux/v1/hotelDataDetailed/fetchHotelDataDetailed';